module.exports = __webpack_public_path__ + "img/summer.3b791b80.png";